import { Component, OnInit,Input } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { FilePage } from 'src/app/pop-overs/files/file/file.page';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.page.html',
  styleUrls: ['./delete.page.scss'],
})
export class DeletePage implements OnInit {

  @Input() email: any = null;
  files: any = null;
  delete_files = false;
  constructor(private modalController: ModalController, public apiService: ApiService, public globalService: GlobalService, private popoverController: PopoverController) { }

  ngOnInit() {
    this.Get();
  }

  async Get() {
    let data: any = await this.apiService.get(`emails/${this.email.guid}`);
    console.log("Email data: ", this.email);
    if (data.success) this.email = data.data[0];
    console.log(this.email);
    console.log("Email data: ", this.email);
  }

  async Delete(){
    var data = {
      delete_files: this.delete_files
    }
    this.modalController.dismiss(data);
  }

  async Close() {
    this.modalController.dismiss(null);
  }

  async presentFilePopover(e, file) {
    e.stopPropagation();
    e.preventDefault();
    const popover = await this.popoverController.create({
      component: FilePage,
      componentProps: { file: file, selected_files: [], minimal: true, show_go_to_folder: true },
      event: e,
      animated: true,
      backdropDismiss: true
    });
    popover.onDidDismiss().then((data) => {
      if (data.data == 4) this.apiService.DownloadFile(file);
      else if (data.data == 8) this.ToggleImportant(file);
      else if (data.data == 9) this.globalService.GoToFileFolder(file.parent_folder_guid);
    });
    return await popover.present();
  }

  async ToggleImportant(file: any) {
    const new_value = !file.is_important;
    const data: any = await this.apiService.put(`files/${file.guid}/important`, { important: new_value });
    if (data.success) {
      file.is_important = new_value;
      this.globalService.presentToastMessage(new_value ? 'Marked as important' : 'Removed from important', true);
    } else {
      this.globalService.presentToastMessage(data.message, false);
    }
  }

}
